var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"billing-details"},_vm._l((_vm.priceMessages),function(msg,index){return _c('div',{key:index},[_c('p',[_vm._v(" "+_vm._s(msg.message)+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }